import {LocationApplication} from '@application/Site';

export const getLocale = (): string => {
  const {country, language} = LocationApplication.getLocale();

  return `${language}-${country}`;
};
